<template>
  <div>
    <div class="container  mt-5">
      <div class="row my-5 py-5 ">

        <div class="col-md-4 d-none d-md-block">

          <img src="@/assets/img/bird.jpg" class="img-fluid">
        </div>
       
        <div class="col-md-7 my-auto offset-md-1">
          <h1  style="font-weight:300">Chamdor</h1>
          <h3 class="font-weight-bold">Card payments portal</h3>
      
          <hr>
              <br>
          <p>Payments for <strong>online shopping orders</strong>, can  be made on this portal by following the card payment option link that you received in your order confirmation
          email.</p>

          <p>
            To create a new order visit our online shop by clicking the button below.
          </p>
          <br><br>
          <a href="https://chamdor.com" class="btn btn-primary mb-3"
            >chamdor.com</a
          >
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {};
</script>
